<div class="parent-modal">
  <!-- Global file input for document upload -->
  <input 
    type="file" 
    id="global-document-file-input"
    accept=".doc,.docx,.pdf,.txt"
    style="display: none; position: absolute;"
    (change)="onFileSelected($event)"
  />
  
  <div class="modal-title-header">
    <div class="mwc-icon-highlight-primary-md me-3">
      <span mwc-icon [mwcIconfont]="'edit-04'" style="font-size: 18px"></span>
    </div>
    <div>
      <div class="mwc-text-lg-semibold mwc-color-gray-900">Build Content for Your Web Pages</div>
    </div>
  </div>
  
  <form mwc-form [formGroup]="workflowForm" class="workflow-form">
    <mwc-tabset
      [mwcTabPosition]="'left'"
      [mwcSelectedIndex]="selectedIndex"
      (mwcSelectedIndexChange)="tabsSetSelectChange($event)">
      <ng-container *ngFor="let tab of tabs; let i = index">
        <ng-container *ngIf="tab.visible">
          <mwc-tab
            [mwcTitle]="titleTemplate"
            (mwcClick)="tabSelectChange(['click', tab])" 
            [mwcDisabled]="tab.disable">
            <ng-template #titleTemplate>
              <div class="d-flex align-items-center">
                <span mwc-icon [mwcIconfont]="tab.iconName" style="font-size: 20px;"></span>
                <span class="mwc-text-sm-medium" style="width: 130px;text-align: left;">{{tab.name}}</span>
              </div>
            </ng-template>
            
            <div style="height: 100%;">
              <!-- Analysis Loading Screen -->
              <div *ngIf="isAnalyzing">
                <div class="mwc-text-xl-medium mwc-color-gray-900">{{ tab.name === 'Analyze Website' ? 'Analyze Website' : 'Analyze Pages' }}</div>
                <div class="analyzing-screen">
                  <div class="analyzing-image">
                    <img src="assets/images/ai-loader.gif" alt="Analyzing" style="height: 50px; width: 50px;">
                  </div>
                  <div class="mwc-text-md-medium mwc-color-gray-700">{{ tab.name === 'Analyze Website' ? 'Analyzing the URL' : 'Analyzing the documents' }}</div>
                  <div class="mwc-text-sm-regular mwc-color-gray-500">This may take some time to analyze <p>and generate the data for you.</p></div>
                </div>
              </div>
              
              <!-- Analyze Website Tab Content -->
              <ng-container *ngIf="tab.name === 'Analyze Website' && !isAnalyzing">
                
                <div class="mwc-text-lg-medium mwc-color-gray-700" style="margin-bottom: 20px;">Analyze Website</div>

                <div class="w-100">
                  <mwc-form-item class="form-item-sec">
                    <mwc-form-label [mwcSpan]="24" class="mwc-text-sm-medium mwc-color-gray-900">Select Brand<span mwc-icon style="font-size: 16px;color:#475467;margin-left: 5px;" mwcIconfont="info-circle" class="help-circle"
                [mwcTooltipTitle]="selectBrandTooltip" mwcTooltipPlacement="top" mwc-button mwc-tooltip></span></mwc-form-label>
                    <ng-template #selectBrandTooltip let-thing>
                      <span class="mwc-text-sm-regular">If you want to manage your brands go to<a mwc-button mwcType="link-color" class="mwc-color-primary-200 ms-1" style="color: #B2CCFF !important;text-decoration: underline;" (click)="manageTemplates()">settings</a></span>
                    </ng-template>
                    <mwc-form-control [mwcSpan]="24">
                      <mwc-select mwcAllowClear [mwcDropdownClassName]="['brand-dropdown','mwc-xs-select-dropdown']" [mwcOptionHeightPx]="36" mwcPlaceHolder="Select" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-regular" style="width: 100% !important;" [ngModelOptions]="{standalone: true}" [(ngModel)]="brandSelectedValue">
                        <mwc-option *ngFor="let option of brandSelection" mwcCustomContent [mwcLabel]="option.label" [mwcValue]="option.value">
                          <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                            {{ option.label }}
                            <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="brandSelectedValue == option.value"></span>
                          </div>
                        </mwc-option>
                      </mwc-select>
                      <!-- <ng-template #renderTemplate>
      <mwc-divider style="margin: 0;"></mwc-divider>
      <div class="container">
        <a mwc-button mwcType="link-color" mwcSize="small" style="text-decoration: none;height: 36px;width: 100%;gap:0;justify-content: flex-start;" class="mwc-text-sm-regular" (click)="openBrandVoiceModal()"><span mwc-icon mwcIconfont="plus" style="font-size: 16px;margin-right: 6px;"></span> New Brand </a>
      </div>
    </ng-template> -->
                    </mwc-form-control>
                  </mwc-form-item>
                </div>
                <div>
                  <!-- <div class="info-msg" style="padding-bottom:12px;" *ngIf="!( (workflowForm.controls['websiteUrl'].value?.length > 0 && !workflowForm.controls['individualUrls'].value?.trim()) || (workflowForm.controls['individualUrls'].value?.trim() && !(workflowForm.controls['websiteUrl'].value?.length > 0)) ) || workflowForm.controls.websiteUrl.invalid || workflowForm.controls.individualUrls.hasError('invalidUrl')">
                    <mwc-alert mwcType="error" mwcMessage="There was an error while analyzing the URL, please check the URL again and retry." mwcCloseable="true" mwcShowIcon="true"></mwc-alert>
                  </div> -->
                  <div *ngIf="isParentUrlVisible">
                    <mwc-form-item class="form-item-sec">
                      <mwc-form-label [mwcSpan]="24" class="mwc-text-sm-medium mwc-color-gray-900">Enter Your Website Domain <span mwc-icon style="font-size: 16px;color:#475467;margin-left: 5px;" mwcIconfont="info-circle" class="help-circle" [mwcTooltipTitle]="'We\'ll automatically detect up to 50 pages on your domain. To include more, add them manually.'" mwcTooltipPlacement="top" mwc-button mwc-tooltip></span></mwc-form-label>
                      <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="websiteUrlError">
                        <mwc-input-group [mwcSuffix]="suffixTemplateInfo">
                          <input mwc-input formControlName="websiteUrl" placeholder="https://example.com" class="mwc-text-sm-regular" mwcSize="small" (input)="parentUrlChange()" (click)="parentUrlChange()"/>
                        </mwc-input-group>
                        <ng-template #suffixTemplateInfo>
                          <mwc-spin [mwcIndicator]="customSpinTpl" *ngIf="workflowForm.controls.websiteUrl.pending" mwcSize="default"></mwc-spin>
                        </ng-template>
                        <ng-template #websiteUrlError let-control>
                          <ng-container *ngIf="control?.dirty || control?.touched">
                            <div *ngIf="control?.hasError('invalidUrl') || control?.hasError('nonHtmlResource')">
                              Enter a valid URL (for example: https://example.com).
                            </div>
                            <div *ngIf="control?.hasError('urlTooLong')">
                              Shorten the URL and try again.
                            </div>
                            <div *ngIf="control?.hasError('pageNotFound')">
                              Page not found. The URL doesn’t point to an existing page.
                            </div>
                            <div *ngIf="control?.hasError('accessRestricted')">
                              Access restricted. This page isn’t publicly accessible.
                            </div>
                            <div *ngIf="control?.hasError('timeout')">
                              Website unreachable. The application took too long to respond.
                            </div>
                            <div *ngIf="control?.hasError('genericError')">
                              Unable to access the URL. Please verify the link and try again.
                            </div>
                            <!--<div *ngIf="control?.hasError('nonHtmlResource')">
                              <div>Unsupported page type</div>
                              <div>Enter a webpage URL, not a file or download.</div>
                            </div>-->
                          </ng-container>
                          <ng-container>
                            <div *ngIf="control?.hasError('emptyUrl')">
                              This field can’t be empty.
                            </div>
                          </ng-container>
                        </ng-template>
                      </mwc-form-control>
                    </mwc-form-item>
                  </div>
                  <div *ngIf="isIndividualUrlVisible">
                    <mwc-form-item class="upload-urls-form-item upload-urls-textarea-item">
                      <mwc-form-label [mwcSpan]="24" class="upload-urls-label">
                        Enter Individual URLs <span class="upload-urls-limit">(Max limit: 100)</span>
                      </mwc-form-label>
                      <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="individualUrlsError">
                        <textarea mwc-input formControlName="individualUrls" placeholder="Enter one URL per row" class="upload-urls-textarea mwc-text-sm-regular" rows="5" (input)="individualUrlsChange()"></textarea>
                      </mwc-form-control>
                      <ng-template #individualUrlsError let-control>
                        <ng-container *ngIf="control?.dirty || control?.touched">
                          <div *ngIf="control?.hasError('invalidUrl') || control?.hasError('nonHtmlResource')">
                            One or more URLs are invalid. Enter a valid URL (for example: https://example.com).
                          </div>
                          <div *ngIf="control?.hasError('multipleDomainsNotAllowed')">
                            All URLs must belong to the same domain.
                          </div>
                          <div *ngIf="control?.hasError('maxUrlsExceeded')">
                            You can enter a maximum of 500 URLs
                          </div>
                          <div *ngIf="control?.hasError('urlTooLong')">
                            Shorten the URL and try again.
                          </div>
                          <!--<div *ngIf="control?.hasError('nonHtmlResource')">
                            <div>Unsupported page type</div>
                            <div>Enter a webpage URL, not a file or download.</div>
                          </div>-->
                        </ng-container>
                        <ng-container>
                          <div *ngIf="control?.hasError('emptyUrl')">
                            This field can’t be empty.
                          </div>
                        </ng-container>
                      </ng-template>  
                    </mwc-form-item>
                  </div>
                  <ng-container *ngIf="isParentUrlVisible && !isIndividualUrlVisible">
                    <div class="mwc-text-sm-medium my-2 mwc-color-gray-500">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="individualUrlsChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter individual URLs</span></a> instead?</div>
                  </ng-container>
                  <ng-container *ngIf="isIndividualUrlVisible && !isParentUrlVisible">
                    <div class="mwc-text-sm-medium my-2 mwc-color-gray-500">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="parentUrlChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter website domain</span></a> instead?</div>
                  </ng-container>
                </div>
              </ng-container>

              <!-- Add Keywords Tab Content -->
              <ng-container *ngIf="tab.name === 'Add Keywords'">
                <ng-container *ngIf="!keywordAnalysisinProgress">
                  <div class="mwc-text-lg-medium mwc-color-gray-700" style="margin-bottom: 20px;">Add or Generate Keywords</div>
                  <div class="mwc-text-sm-medium mwc-color-gray-900 d-flex align-items-center" style="margin-bottom: 8px;">What are the keywords you would like to target? <span mwc-icon style="font-size: 16px;color:#475467;margin-left: 5px;" mwcIconfont="info-circle" class="help-circle" [mwcTooltipTitle]="'Add the keywords that you want to assign to individual pages'" mwcTooltipPlacement="top" mwc-button mwc-tooltip></span></div>

                  <!-- Keywords input section -->
                  <div class="selected-keywords" *ngIf="isKeywordTagsVisible">
                    <mwc-tag *ngFor="let selectedKeyword of allKeywords; let i = index" [mwcMode]="'closeable'" (mwcOnClose)="removeKeyword(selectedKeyword)" class="mwc-input-tag-list mwc-text-xs-medium" mwc-tooltip [mwcTooltipTitle]="selectedKeyword">
                      {{ sliceKeyword(selectedKeyword) }}
                    </mwc-tag>
                    <span *ngIf="!keywordInputVisible && !(allKeywords.length >= maxKeywordsAllowed)"
                          class="editable-tag mwc-text-sm-regular mwc-color-gray-400"
                          mwcNoAnimation (click)="showKeywordInput()"
                          style="width:150px;display:flex; align-items: center; height: 22px;">{{ allKeywords.length > 0 ? '+ More Keywords' : '+ Add Keyword' }}</span>
                    <input #inputElement mwc-input mwcSize="small" *ngIf="keywordInputVisible" type="text"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedKeywordInputValue"
                          (blur)="addKeywordToSelectedKeywords()" (keydown.enter)="addKeywordToSelectedKeywords()"
                          (keydown.comma)="handleCommaKeyword($event)" (input)="handleKeywordInput($event)"
                          class="mwc-tag-input mwc-text-sm-regular"  />
                  </div>
                  
                  <mwc-form-item class="form-item-sec mt-2" *ngIf="isKeywordUploadVisible">
                    <mwc-form-control [mwcSpan]="24">
                      <div style="display: flex;flex-direction: column;" class="bulk-upload">
                        <ng-container>
                          <mwc-upload mwcType="drag" [mwcMultiple]="false" mwcAccept=".xlsx, .xls" (mwcChange)="handleChange($event)" [(mwcFileList)]="fileList" [mwcHint]="'XLSX, XLS'" [mwcBeforeUpload]="beforeUpload">
                          <ng-template #renderTemplate>
                            <span mwc-icon style="font-size: 16px;" [mwcIconfont]="(fileList[0] && (fileList[0].percent >= 100 || fileList[0].status == 'done' )? 'check-circle':'file-04')"></span>
                          </ng-template>
                          </mwc-upload>
                        </ng-container>
                      </div>
                      <div style="display: flex; align-items: flex-start; gap: 10px; padding: 10px 12px; background: #F0F9FF; border: 1px solid #BAE6FD; border-radius: 8px; margin-top: 10px;">
                        <span mwc-icon mwcIconfont="info-circle" style="font-size: 15px; color: #0284C7; margin-top: 1px; flex-shrink: 0;"></span>
                        <div style="display: flex; flex-direction: column; gap: 4px;">
                          <span class="mwc-text-sm-medium" style="color: #0C4A6E;">Use our pre-formatted template for best results</span>
                          <span class="mwc-text-xs-regular" style="color: #0369A1;">
                            Fill in your keywords using the sample file and upload it here.
                          </span>
                          <a mwc-button mwcType="link-color" style="padding: 0; width: fit-content; margin-top: 2px;" (click)="downloadKeywordSample()">
                            <span mwc-icon mwcIconfont="download-01" style="font-size: 13px; margin-right: 4px;"></span>
                            <span class="mwc-text-xs-medium" style="color: #0284C7; text-decoration: underline;">Download sample file</span>
                          </a>
                        </div>
                      </div>
                    </mwc-form-control>
                  </mwc-form-item>
                  <ng-container *ngIf="isKeywordTagsVisible && !isKeywordUploadVisible">
                    <div class="mwc-text-sm-medium my-2 mwc-color-gray-500">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="keywordTagsChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">upload keywords</span></a> instead?</div>
                  </ng-container>
                  <ng-container *ngIf="isKeywordUploadVisible && !isKeywordTagsVisible">
                    <div class="mwc-text-sm-medium my-2 mwc-color-gray-500">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="keywordUploadChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">add keywords manually</span></a> instead?</div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="keywordAnalysisinProgress">
                  <mwc-card style="width:100%;" class="keyword-card">
                    <div class="analysis-in-progress keyword-analysis-in-progress" style="display:none;">
                      <div class="analysis-in-progress-img m-0"><img src="assets/images/ai-loader.gif" alt="Analyzing" style="height: 50px; width: 50px;"></div>
                      <div>
                        <div class="mwc-text-xl-regular">Analysis in Progress</div>
                        <div class="mwc-text-sm-regular mwc-color-gray-600" style="width: 480px;">We’re analyzing your keywords and matching them to your templates. Please wait <span class="mwc-text-sm-medium mwc-color-gray-800">this will only take few moment.</span></div>
                      </div>
                    </div>
                  </mwc-card>
                </ng-container>
              </ng-container>

              <!-- Webpages Tab Content -->
              <ng-container *ngIf="tab.name === 'Webpages'">
                <div style="display: flex; justify-content: space-between;">
                  <div class="mwc-text-lg-medium mwc-color-gray-700">Pages</div>
                  <div>
                    <button (click)="manageTemplates()" mwc-button mwcType="text" mwcSize="small" style="margin-right: 12px;box-shadow: none;">
                      <span mwc-icon mwcIconfont="settings-01" style="font-size: 16px;"></span>
                      Manage Templates
                    </button>
                    <button mwc-button mwcType="default-color" mwcSize="small"  (click)="addNewSection()" style="box-shadow: none;">
                      <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>
                      Add Page
                    </button>
                  </div>
                </div>
                <div class="info-msg" style="padding-top:12px;" *ngIf="isButtonDisabled()">
                  <mwc-alert mwcType="error" mwcMessage="Each URL must have at least one keyword and one template selected." mwcCloseable="true" mwcShowIcon="true"></mwc-alert>
                </div>
                <div class="page-config-table-container">
                  <mwc-table [mwcData]="pageData" [mwcFrontPagination]="false" [mwcShowPagination]="false" [mwcLoadingIndicator]="tableSpinTpl" mwcTableLayout="fixed">
                    <thead>
                      <tr>
                        <!-- <th [mwcChecked]="checked" [mwcIndeterminate]="indeterminate" (mwcCheckedChange)="onAllChecked($event)" class="mwc-text-sm-medium" [mwcWidth]="'40px'"></th> -->
                        <th class="mwc-text-sm-medium" [mwcWidth]="'auto'">Web Pages</th>
                        <th class="mwc-text-sm-medium" [mwcWidth]="'250px'">Keywords Assigned</th>
                        <th class="mwc-text-sm-medium" [mwcWidth]="'170px'">Template</th>
                        <th [mwcWidth]="'100px'"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- New Section Form Row -->
                      <ng-container *ngIf="isAddingNewSection">
                        <td>
                          <div style="display: flex; align-items: center; gap: 8px;">
                            <input type="text" [(ngModel)]="newSection.title" class="rename-input mwc-text-sm-regular" mwc-input mwcSize="small" style="box-shadow: none;" [ngModelOptions]="{standalone: true}"/>
                          </div>
                        </td>
                        <td>
                          <div class="keyword-tags">
                            <ng-container *ngIf="newSection.keywords && newSection.keywords.length > 0; else noKeywords">
                              <div class="tag-outline-list">
                                <div class="tag-list template-tags">
                                  <mwc-tag *ngFor="let pageTemplateTag of newSection.keywords | slice:0:2;let kidx = index " [mwcColor]="'gray-outline'" mwcMode="closeable" (mwcOnClose)="newSection.keywords.splice(kidx, 1)" mwc-tooltip [mwcTooltipTitle]="pageTemplateTag.toString()"><span class="template-name">{{pageTemplateTag}}</span></mwc-tag>
                                  <mwc-tag *ngIf="(newSection.keywords.length - 2) > 0 " mwc-dropdown [mwcDropdownMenu]="menu4" mwcTrigger="hover" [mwcPlacement]="'bottomLeft'" style="cursor: pointer;" [mwcColor]="'gray-outline'" class="tag-count">+{{newSection.keywords.length - 2}} </mwc-tag>
                                  <!-- Add new tag button with dropdown menu -->
                                  <div class="keyword-plus-button">
                                    <a (click)="addNewKeywordToPage(newSection.id)" class="mwc-text-sm-regular"  mwc-dropdown  [mwcDropdownMenu]="keywordMenu" mwcTrigger="click" mwcPlacement="bottomLeft" style="display: block;width: 22px;padding: 5px 4px;">
                                      <span mwc-icon mwcIconfont="plus" style="font-size: 16px;display: block;"></span>
                                    </a>
                                  </div>
                                </div>
                                <mwc-dropdown-menu #menu4="mwcDropdownMenu">
                                  <ul mwc-menu style="width: 150px;max-height: 110px;overflow-y: auto;">
                                    <li mwc-menu-item class="mwc-text-xs-medium" *ngFor="let tag of newSection.keywords | slice:2:newSection.keywords.length;let kidx = index" mwc-tooltip [mwcTooltipTitle]="tag.toString()">
                                      <span class="d-tag">{{ tag }}</span>
                                      <span mwc-icon mwcIconfont="x-close" (click)="newSection.keywords.splice(kidx + 2, 1)"></span>
                                    </li>
                                  </ul>
                                </mwc-dropdown-menu>
                              </div>
                            </ng-container>
                            <ng-template #noKeywords>
                              <mwc-tag mwc-dropdown [mwcDropdownMenu]="keywordMenu"  mwcTrigger="click" mwcPlacement="bottomLeft" style="cursor: pointer;border-radius: 6px;border-color: #D0D5DD;margin: 0;display: flex;align-items: center;gap: 5px;" [mwcColor]="'gray-outline'" (click)="addNewKeywordToPage(newSection.id)"> Select Keyword</mwc-tag>
                            </ng-template>
                            
                            <!-- Keyword selection dropdown menu -->
                            <mwc-dropdown-menu #keywordMenu="mwcDropdownMenu">
                              <ul mwc-menu>
                                <li style="padding: 2px 6px 6px 6px;">
                                  <div class="keyword-dropdown-content" (click)="$event.stopPropagation()">
                                    <div class="keyword-options">
                                      <div *ngFor="let option of listOfOption" 
                                          class="keyword-option mwc-text-sm-regular" 
                                          [class.selected]="isKeywordSelected(option.label)"
                                          (click)="toggleKeywordSelection(option.label); $event.stopPropagation();">
                                        <span class="option-checkbox">
                                          <span *ngIf="isKeywordSelected(option.label)" mwc-icon mwcIconfont="check" class="check-icon"></span>
                                        </span>
                                        <span class="mwc-text-sm-medium mwc-color-gray-900">{{ option.label }}</span>
                                      </div>
                                    </div>
                                    <!--add keyword-->
                                    <div class="new-keyword">
                                      <div class="d-flex align-items-center" style="justify-content: space-between;gap:8px">
                                        <div>
                                          <input mwc-input placeholder="Enter keyword" [ngModelOptions]="{standalone: true}" [(ngModel)]="newTagText" (input)="onNewTagInput()" class="mwc-text-sm-regular" [ngClass]="{'input-error': isDuplicateKeyword}" *ngIf="showTagInput"/>
                                        </div>
                                        <div class="d-flex align-items-center">
                                          <button mwc-button mwcType="primary" mwcSize="small" (click)="addNewTag(); $event.stopPropagation();" class="mwc-text-sm-regular" *ngIf="showTagInput" [disabled]="isDuplicateKeyword || !newTagText.trim()"><span mwc-icon mwcIconfont="check"></span></button>
                                          <!-- <button mwc-button mwcType="primary" mwcSize="small" (click)="openNewInputTag(); $event.stopPropagation();" class="mwc-text-sm-regular" *ngIf="!showTagInput">+ Add</button> -->
                                        </div>
                                      </div>
                                      <div *ngIf="isDuplicateKeyword" class="mwc-text-xs-regular" style="color: #F04438; margin-top: 4px;">This keyword already exists.</div>
                                    </div>
                                    <div class="keyword-actions">
                                      <button mwc-button mwcType="default" mwcSize="small" (click)="cancelKeywordSelection(); $event.stopPropagation();" class="mwc-text-sm-regular">
                                        Cancel
                                      </button>
                                      <button mwc-button mwcType="primary" mwcSize="small"  (click)="confirmNewKeywordSelection(); $event.stopPropagation();"  [disabled]="selectedKeywords.length === 0" class="mwc-text-sm-regular">
                                        Select Keywords
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </mwc-dropdown-menu>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center" style="width: 130px;">
                            <mwc-select mwcSize="small" class="mwc-text-sm-regular template-select"  [(ngModel)]="newSection.template" [ngModelOptions]="{standalone: true}" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 100% !important;" [mwcOptionHeightPx]="36" mwcPlaceHolder="Select">
                              <mwc-option *ngFor="let option of templateOptions" [mwcLabel]="option.label" [mwcValue]="option.value">
                                {{ option.label }}
                              </mwc-option>
                            </mwc-select>
                          </div>
                        </td>
                        <td>
                          <div style="display: flex; align-items: center; gap: 8px;">
                            <button mwc-button mwcSize="small" mwcType="text" class="mwc-text-sm-medium" (click)="saveNewSection();" style="width: 34px;height: 34px;box-shadow: none;"><span mwc-icon mwcIconfont="check" style="font-size: 18px;color: #667085;"></span></button>
                            <button mwc-button mwcSize="small" mwcType="text" class="mwc-text-sm-medium" (click)="cancelAddSection();"><span mwc-icon mwcIconfont="x-close" style="font-size: 18px;color: #667085;"></span></button>
                          </div>
                        </td>
                      </ng-container>
                      <!-- Existing Sections -->
                      <!-- Dynamically generate rows for each page -->
                      <tr *ngFor="let page of pageData; let i = index">
                        <!-- <td [mwcChecked]="setOfCheckedId.has(page.id)" (mwcCheckedChange)="onItemChecked(page.id, $event)"></td> -->
                        <td>
                          <div *ngIf="editingPagenId !== page.id; else editPage">
                            <div mwc-typography mwcEllipsis [mwcEllipsisRows]="1" class="m-0 mwc-color-gray-600 mwc-text-sm-regular" mwc-tooltip [mwcTooltipTitle]="page.title">
                              {{ page.title }}
                            </div>
                          </div>
                          <ng-template #editPage>
                            <div style="display: flex; align-items: center; gap: 8px;">
                              <input type="text" [(ngModel)]="page.title" class="rename-input mwc-text-sm-regular" mwc-input mwcSize="small" style="box-shadow: none;" [ngModelOptions]="{standalone: true}"/>
                            </div>
                          </ng-template>
                          <!-- <div class="mwc-text-xs-regular mwc-color-gray-600 m-0" mwc-typography mwcEllipsis mwc-tooltip [mwcTooltipTitle]="page.url" style="width: 90%;">{{ page.url }}</div> -->
                        </td>
                        <td>
                          <div class="keyword-tags">
                            <ng-container *ngIf="page.keywords && page.keywords.length > 0; else noKeywords">
                              <div class="tag-outline-list">
                                <div class="tag-list template-tags">
                                  <mwc-tag *ngFor="let pageTemplateTag of page.keywords | slice:0:2;let kidx = index " [mwcColor]="'gray-outline'" mwcMode="closeable" (mwcOnClose)="page.keywords.splice(kidx, 1)" mwc-tooltip [mwcTooltipTitle]="pageTemplateTag.toString()"><span class="template-name">{{pageTemplateTag}}</span></mwc-tag>
                                  <mwc-tag *ngIf="(page.keywords.length - 2) > 0 " mwc-dropdown [mwcDropdownMenu]="menu4" mwcTrigger="hover" [mwcPlacement]="'bottomLeft'" style="cursor: pointer;" [mwcColor]="'gray-outline'" class="tag-count">+{{page.keywords.length - 2}} </mwc-tag>
                                  <!-- Add new tag button with dropdown menu -->
                                  <div class="keyword-plus-button">
                                    <a (click)="addKeywordToPage(i)" class="mwc-text-sm-regular"  mwc-dropdown  [mwcDropdownMenu]="keywordMenu" mwcTrigger="click" mwcPlacement="bottomLeft" style="display: block;width: 22px;padding: 5px 4px;">
                                      <span mwc-icon mwcIconfont="plus" style="font-size: 16px;display: block;"></span>
                                    </a>
                                  </div>
                                </div>
                                <mwc-dropdown-menu #menu4="mwcDropdownMenu">
                                  <ul mwc-menu style="width: 150px;max-height: 110px;overflow-y: auto;">
                                    <li mwc-menu-item class="mwc-text-xs-medium" *ngFor="let tag of page.keywords | slice:2:page.keywords.length;let kidx = index" mwc-tooltip [mwcTooltipTitle]="tag.toString()">
                                      <span class="d-tag">{{ tag }}</span>
                                      <span mwc-icon mwcIconfont="x-close" (click)="page.keywords.splice(kidx + 2, 1)"></span>
                                    </li>
                                  </ul>
                                </mwc-dropdown-menu>
                              </div>
                            </ng-container>
                            <ng-template #noKeywords>
                              <mwc-tag mwc-dropdown [mwcDropdownMenu]="keywordMenu"  mwcTrigger="click" mwcPlacement="bottomLeft" style="cursor: pointer;border-radius: 6px;border-color: #D0D5DD;margin: 0;display: flex;align-items: center;gap: 5px;" [mwcColor]="'gray-outline'" (click)="addKeywordToPage(i)"><span mwc-icon mwcIconfont="alert-triangle" style="color:#F79009;font-size: 15px;"></span> Select Keyword</mwc-tag>
                            </ng-template>
                            
                            <!-- Keyword selection dropdown menu -->
                            <mwc-dropdown-menu #keywordMenu="mwcDropdownMenu">
                              <ul mwc-menu>
                                <li style="padding: 2px 6px 6px 6px;">
                                  <div class="keyword-dropdown-content" (click)="$event.stopPropagation()">
                                    <!-- <div class="mwc-text-sm-medium mwc-color-gray-700 pb-2">Select Keywords</div> -->
                                    <div class="keyword-options">
                                      <div *ngFor="let option of listOfOption" 
                                          class="keyword-option mwc-text-sm-regular" 
                                          [class.selected]="isKeywordSelected(option.label)"
                                          (click)="toggleKeywordSelection(option.label); $event.stopPropagation();">
                                        <span class="option-checkbox">
                                          <span *ngIf="isKeywordSelected(option.label)" mwc-icon mwcIconfont="check" class="check-icon"></span>
                                        </span>
                                        <span class="mwc-text-sm-medium mwc-color-gray-900">{{ option.label }}</span>
                                      </div>
                                    </div>
                                    <!--add keyword-->
                                    <div class="new-keyword">
                                      <div class="d-flex align-items-center" style="justify-content: space-between;gap:8px">
                                        <div>
                                          <input mwc-input placeholder="Enter keyword" [ngModelOptions]="{standalone: true}" [(ngModel)]="newTagText" (input)="onNewTagInput()" class="mwc-text-sm-regular" [ngClass]="{'input-error': isDuplicateKeyword}" *ngIf="showTagInput"/>
                                        </div>
                                        <div class="d-flex align-items-center">
                                          <button mwc-button mwcType="primary" mwcSize="small" (click)="addNewTag(); $event.stopPropagation();" class="mwc-text-sm-regular" *ngIf="showTagInput" [disabled]="isDuplicateKeyword || !newTagText.trim()"><span mwc-icon mwcIconfont="check"></span></button>
                                          <!-- <button mwc-button mwcType="primary" mwcSize="small" (click)="openNewInputTag(); $event.stopPropagation();" class="mwc-text-sm-regular" *ngIf="!showTagInput">+ Add</button> -->
                                        </div>
                                      </div>
                                      <div *ngIf="isDuplicateKeyword" class="mwc-text-xs-regular" style="color: #F04438; margin-top: 4px;">This keyword already exists.</div>
                                    </div>
                                    <div class="keyword-actions">
                                      <button mwc-button mwcType="default" mwcSize="small" (click)="cancelKeywordSelection(); $event.stopPropagation();" class="mwc-text-sm-regular">
                                        Cancel
                                      </button>
                                      <button mwc-button mwcType="primary" mwcSize="small"  (click)="confirmKeywordSelection(); $event.stopPropagation();"  [disabled]="selectedKeywords.length === 0" class="mwc-text-sm-regular">
                                        Select Keywords
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </mwc-dropdown-menu>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center" [ngClass]="{'template-select-error': !page.template || page.template === '' || page.template === '00000000-0000-0000-0000-000000000000'}" style="width: 130px;">
                            <span mwc-icon mwcIconfont="alert-triangle" style="color: #F79009;font-size: 15px;position: absolute;left: 8px;top: 11px;z-index: 9;" *ngIf="!page.template || page.template === '' || page.template === '00000000-0000-0000-0000-000000000000'"></span>
                            <mwc-select mwcSize="small" class="mwc-text-sm-regular template-select"  [(ngModel)]="page.template" [ngModelOptions]="{standalone: true}" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 100% !important;" [mwcOptionHeightPx]="36" mwcPlaceHolder="Select">
                              <mwc-option *ngFor="let option of templateOptions" [mwcLabel]="option.label" [mwcValue]="option.value">
                                {{ option.label }}
                              </mwc-option>
                            </mwc-select>
                          </div>
                        </td>
                        <td>
                          <ng-container *ngIf="editingPagenId !== page.id; else editActions">
                            <button mwc-button mwcSize="small" mwcType="link" mwc-dropdown mwcTrigger="click" [mwcDropdownMenu]="tableActions" [mwcPlacement]="'bottomRight'"> <span mwc-icon mwcIconfont="dots-vertical" style="color:#475467"></span> </button>
                            <mwc-dropdown-menu #tableActions="mwcDropdownMenu">
                              <ul mwc-menu style="width: 160px;">
                                <li mwc-menu-item (click)="renamePage(page)"><span mwc-icon mwcIconfont="edit-03" style="font-size: 16px;margin-right: 8px;color: #667085;"></span>Edit</li>
                                <li mwc-menu-item (click)="deletePage(page)" style="color: #B42318 !important;"><span mwc-icon mwcIconfont="trash-01" style="font-size: 16px;margin-right: 8px; color: #F04438;"></span>Delete</li>
                              </ul>
                            </mwc-dropdown-menu>
                          </ng-container>
                          <ng-template #editActions>
                            <div style="display: flex; align-items: center; gap: 8px;">
                              <button mwc-button mwcSize="small" mwcType="text" class="mwc-text-sm-medium" (click)="savePageName(page); $event.stopPropagation();" style="width: 34px;height: 34px;box-shadow: none;"><span mwc-icon mwcIconfont="check" style="font-size: 18px;color: #667085;"></span></button>
                              <button mwc-button mwcSize="small" mwcType="text" class="mwc-text-sm-medium" (click)="cancelEditing(); $event.stopPropagation();"><span mwc-icon mwcIconfont="x-close" style="font-size: 18px;color: #667085;"></span></button>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </mwc-table>
                </div>
              </ng-container>

              <!-- Upload Docs Tab Content -->
              <ng-container *ngIf="tab.name === 'Upload Docs'">
                <div class="quick-upload-container" style="width: 100%;">
                  <div class="quick-upload-header">
                    <div class="quick-upload-info">
                      <div class="mwc-text-lg-medium mwc-color-gray-700 d-flex align-items-center">Upload Content Instructions <span mwc-icon style="font-size: 16px;color:#475467;margin-left: 5px;" mwcIconfont="info-circle" class="help-circle" [mwcTooltipTitle]="'Upload like your content guide, brand guide, style of writing guide, etc.'" mwcTooltipPlacement="top" mwc-button mwc-tooltip></span></div>
                    </div>
                    <!-- Add Document Button - only visible when at least one doc is uploaded, and disabled when max documents reached -->
                    <button mwc-button mwcType="link-color" mwcSize="small" (click)="onAddDocument()" id="addDocumentButton" *ngIf="uploadedFiles.length > 0 && !isUploadAnalyzing" [disabled]="uploadedFiles.length >= maxDocuments">
                      <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>
                      Add Document ({{uploadedFiles.length}}/{{maxDocuments}})
                    </button>
                  </div>
                  <ng-container *ngIf="isUploadAnalyzing">
                    <div class="analyzing-screen" style="width: 100%;">
                      <div class="analyzing-image">
                        <img src="assets/images/ai-loader.gif" alt="Analyzing" style="height: 50px; width: 50px;">
                      </div>
                      <div class="mwc-text-md-medium mwc-color-gray-700">Analyzing the documents</div>
                      <div class="mwc-text-sm-regular mwc-color-gray-500">This may can take sometime to analyze <br>and populate the content instructions</div>
                    </div>
                  </ng-container>
                  <!-- Upload initial state - only shown when no files are being uploaded -->
                  <div class="upload-area" *ngIf="uploadedFiles.length === 0" style="width: 100%;" (click)="onAddDocument()">
                    <div class="upload-placeholder">
                      <div class="mwc-icon-highlight-primary-md">
                      <span mwc-icon mwcIconfont="upload-cloud-02" style="font-size: 20px; color: #667085;"></span>
                      </div>
                      <button mwc-button mwcType="link-color" mwcSize="small" class="mt-2" id="browseFilesButton" >Click to upload</button>
                      <div class="mwc-text-xs-regular mwc-color-gray-600 mt-2">Upload file size: 10KB to 5 MB</div>
                      <div class="mwc-text-xs-regular mwc-color-gray-600 mt-1">Accepted file type: DOC, DOCX & PDF</div>
                      <input 
                        type="file" 
                        #fileInput
                        id="document-file-input"
                        accept=".doc,.docx,.pdf,.xls,.xlsx,.txt"
                        style="display: none; position: absolute;"
                        (change)="onFileSelected($event)"
                      />
                    </div>
                  </div>

                  <!-- File upload controls - only shown when there are files -->
                  <div *ngIf="uploadedFiles.length > 0 && !isUploadAnalyzing" class="uploaded-files-section" style="width: 100%;height: 365px;overflow: scroll;padding-right: 8px;">
                    <!-- Uploaded Files List with scrolling -->
                    <div class="uploaded-files-list" style="width: 100%;">
                      <mwc-card *ngFor="let file of uploadedFiles" class="file-upload-card" style="width: 100%;">
                        <div class="file-upload-content w-100">
                          <div class="file-info-section w-100">
                            <div class="file-icon-wrapper">
                              <div class="mwc-icon-highlight-primary-md">
                                <span mwc-icon mwcIconfont="file-04" style="font-size: 16px; color: #155EEF;"></span>
                              </div>
                            </div>
                            <div class="file-details">
                              <div class="file-main-info">
                                <div mwc-typography mwcEllipsis class="file-name mwc-text-sm-medium mwc-color-gray-700 m-0">{{file.name}}</div>
                                <div class="file-size mwc-text-sm-regular mwc-color-gray-600">{{file.size}}</div>
                              </div>
                              <div class="progress-section" *ngIf="file.progress < 100">
                                <div class="progress-bar-container">
                                  <mwc-progress [mwcPercent]="file.progress" mwcSize="small" [mwcShowInfo]="true" [mwcFormat]="percentFormat"></mwc-progress>
                                </div>
                              </div>
                              <div class="divider-line"></div>
                              <div class="document-type-section">
                                <div class="mwc-text-sm-medium mwc-color-gray-700" style="margin-bottom: 6px;">Document Type</div>
                                  <mwc-select
                                  mwcSize="small"
                                  mwcPlaceholder="Enter"
                                  [(ngModel)]="file.documentType"
                                  [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="onDocumentTypeChange(file.id, $event)"
                                  [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium document-type-select" [mwcOptionHeightPx]="36"  mwcPlaceHolder="Select">
                                  <mwc-option *ngFor="let option of documentTypeOptions" [mwcLabel]="option.label" [mwcValue]="option.value">
                                    {{ option.label }}
                                  </mwc-option>
                                </mwc-select>
                              </div>
                              <div class="mt-2 w-100" *ngIf="file.documentType === 'other'">
                                <div class="mwc-text-sm-medium mwc-color-gray-700" style="margin-bottom: 6px;">Specify Document Type</div>
                                <input mwc-input mwcSize="small" [(ngModel)]="file.documentDescription" [ngModelOptions]="{standalone: true}" placeholder="Enter Specify Document Type" class="mwc-text-sm-regular" mwcSize="small"/>
                              </div>
                            </div>
                          </div>
                          <div class="remove-file-button">
                            <button mwc-button mwcType="link" mwcSize="small" (click)="removeUploadedFile(file.id)">
                              <span mwc-icon mwcIconfont="trash-01" style="font-size: 20px; color: #F04438;"></span>
                            </button>
                          </div>
                        </div>
                      </mwc-card>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Brand Voice Tab Content -->
              <ng-container *ngIf="tab.name === 'Brand Voice'">
                <ng-container *ngIf="isNoCreateBrandVoice">
                  <div class="empty-screen-branch-voice">
                    <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                    <div>
                      <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                      <div class="mwc-text-sm-regular mwc-color-gray-600">Add a brand voice using the button below to start creating intelligent content</div>
                    </div>
                    <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Brand Voice</button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isNoCreateBrandVoice">
                  <div class="d-flex align-items-center mb-3 justify-content-between">
                    <div class="mwc-text-lg-medium">{{tab.name}}</div>
                    <div class="d-flex align-items-center gap-2">
                      <ng-container *ngIf="!isShowDetailsBV">
                        <button mwc-button mwcType="link" mwcSize="small" (click)="reloadList('brandVoice')" style="margin-right: 8px;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px;"></span> Refresh </button>
                        <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                      </ng-container>
                      <ng-container *ngIf="isShowDetailsBV">
                        <button mwc-button mwcType="default-color" mwcSize="small" (click)="changeBV()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span> Change Brand Voice </button>
                      </ng-container>
                    </div>
                  </div>
                  <ng-container *ngIf="!isShowDetailsBV">
                    <div style="width: 100%;margin: 0 auto 16px 0;">
                      <mwc-input-group [mwcPrefix]="prefixIconSearch" >
                        <input mwc-input [formControl]="bvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchBV()" placeholder="Search from all existing brand voices by name" mwcSize="small" />
                      </mwc-input-group>
                      <ng-template #prefixIconSearch>
                        <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                      </ng-template>
                    </div>
                    <ng-container *ngIf="!FoundSerchBV">
                      <div class="empty-screen-branch-voice">
                        <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="grid-sec" *ngIf="FoundSerchBV">
                      <mwc-card *ngFor="let bvCard of filteredBrandVoiceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}"  style="cursor: pointer;" [ngClass] ="(bvCard.isDefault || bvCard.isSelectedBV) ? 'select-grid':''" >
                        <div class="get-started-overlay">
                          <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedBV(bvCard.value)">
                            <span class="mwc-text-sm-medium">{{(bvCard.isDefault || bvCard.isSelectedBV) ? 'Selected' : 'Select'}}</span>
                          </button>
                          <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectBV(bvCard.value)">
                            <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                            <span class="mwc-text-sm-medium">View Details</span>
                          </a>
                        </div>
                        <div>
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{bvCard.label}}</div>
                          </div>
                          <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(bvCard.createdOn)}}</span></div>
                          <div class="mwc-text-xs-regular mt-3 mb-1"><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.tone}}</span></div>
                          <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.createdBy}}</span></div>
                        </div>
                      </mwc-card>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isShowDetailsBV">
                    <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                      <div style="display: flex;align-items: flex-start;gap: 8px;justify-content: space-between;border-bottom: 1px solid #EAECF0;padding-bottom: 12px;">
                        <div class="d-flex align-items-center gap-2">
                          <div style="width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                            <div style="display: flex; color: #667085">
                              <span mwc-icon mwcIconfont="clipboard-report"></span>
                            </div>
                          </div>
                          <div>
                            <div class="mwc-text-md-medium mwc-color-gray-700">{{brandVoiceDetails?.label}}</div>
                            <div style="display: flex;align-items: center;gap:8px">
                              <div><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.tone}}</span></div>
                              <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.createdBy}}</span></div>
                              <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(brandVoiceDetails?.createdOn)}}</span></div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultBVAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                        </div>
                      </div>
                      <div style="margin: 12px 0 0;">
                        <div  class="mwc-text-sm-regular mwc-color-gray-500" [innerHTML]="brandVoiceDetails.brandVoiceDocument" style="white-space: pre-wrap;"></div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- Target Audience Tab Content -->
              <ng-container *ngIf="tab.name == 'Target Audience'">
                <ng-container *ngIf="isNoTargetAudience">
                  <div class="empty-screen-branch-voice">
                    <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                    <div>
                      <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No target audience found</div>
                      <div class="mwc-text-sm-regular mwc-color-gray-600">Add a target audience using the button below to start creating intelligent content</div>
                    </div>
                    <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Target Audience</button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isNoTargetAudience">
                  <div class="d-flex align-items-center mb-3 justify-content-between">
                    <div class="mwc-text-lg-medium">{{tab.name}}</div>
                    <div class="d-flex align-items-center gap-2">
                      <ng-container *ngIf="!isShowDetailsTA">
                        <button mwc-button mwcType="link" mwcSize="small" (click)="reloadList('targetAudience')" style="margin-right: 8px;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px;"></span> Refresh </button>
                        <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                      </ng-container>
                      <ng-container *ngIf="isShowDetailsTA">
                        <button mwc-button mwcType="default" mwcSize="small" (click)="viewAllTA()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span>View all </button>
                      </ng-container>
                    </div>
                  </div>
                  <ng-container *ngIf="!isShowDetailsTA">
                    <div style="width: 100%;margin: 0 auto 16px 0;">
                      <mwc-input-group [mwcPrefix]="prefixIconSearch">
                        <input mwc-input [formControl]="tvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchTA()" placeholder="Search from all existing personas by name" mwcSize="small" />
                      </mwc-input-group>
                      <ng-template #prefixIconSearch>
                        <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                      </ng-template>
                    </div>
                    <ng-container *ngIf="!FoundSearchTA">
                      <div class="empty-screen-branch-voice">
                        <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No target audience found</div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="grid-sec" *ngIf ="FoundSearchTA">
                      <mwc-card *ngFor="let taCard of filteredTargetAudienceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(taCard.isDefault || taCard.isSelectedTA) ? 'select-grid':''">
                        <div class="get-started-overlay">
                          <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedTA(taCard.title)">
                            <span class="mwc-text-sm-medium">{{ taCard.isDefault || taCard.isSelectedTA ? 'Selected': 'Select' }}</span>
                          </button>
                          <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectTV(taCard.title)">
                            <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                            <span class="mwc-text-sm-medium">View Details</span>
                          </a>
                        </div>
                        <div>
                          <div class="d-flex align-items-center justify-content-between">
                            <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{taCard.title}}</div>
                          </div>
                          <div class="mb-2"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(taCard.createdDate)}}</span></div>
                          <div style="line-height: normal;">
                            <span class="mwc-text-xs-regular mwc-color-gray-500">Gender: </span>
                            <ng-container *ngFor="let gender of taCard.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                              <span class="mwc-text-xs-medium mwc-color-gray-700">{{gender}}</span> <span class="me-1" *ngIf="!last">{{!last ? ',' : '&'}}</span>
                            </ng-container>
                          </div>
                          <div style="line-height: normal;">
                            <span class="mwc-text-xs-regular mwc-color-gray-500">Age group: </span>
                            <ng-container *ngFor="let age of taCard.thingTargetAudience.thingJson.ageGroup;let last = last;">
                              <span class="mwc-text-xs-medium mwc-color-gray-700">{{age}}</span>
                              <span class="me-1" *ngIf="!last">{{taCard.thingTargetAudience.thingJson.ageGroup.length - 1  ? ',' : '&'}}</span>
                            </ng-container>
                          </div>
                        </div>
                      </mwc-card>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isShowDetailsTA">
                    <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                      <div style="display: flex;align-items: center;gap: 8px;justify-content: space-between;">
                        <div class="d-flex align-items-center gap-2">
                          <div style="min-width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                            <div style="display: flex; color: #667085">
                              <span mwc-icon mwcIconfont="users-03"></span>
                            </div>
                          </div>
                          <div>
                            <div class="mwc-text-md-medium mwc-color-gray-700" mwc-typography mwcEllipsis style="margin: 0;width: 86%;">{{targetAudienceDetails?.title}}</div>
                            <div style="display: flex;align-items: center;gap:8px">
                              <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{targetAudienceDetails?.authorName}}</span></div>
                              <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(targetAudienceDetails.createdDate)}}</span></div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultTAAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                        </div>
                      </div>
                      <div style="margin-top: 12px;border-top: 1px solid #efefef;padding-top: 10px;">
                        <div mwc-row [mwcGutter]="[24,12]">
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1"> Age Group: </div>
                            <ng-container>
                              <div class="view-layout">
                                <ng-container *ngFor="let age of targetAudienceDetails.thingTargetAudience.thingJson.ageGroup;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium mwc-color-gray-700">{{age}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </ng-container>
                              </div>
                            </ng-container>
                          </div>
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Family Status:</div>
                            <ng-container>
                              <div class="view-layout">
                                <div *ngFor="let status of targetAudienceDetails.thingTargetAudience.thingJson.relationshipStatus;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium">{{status}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Gender:</div>
                            <ng-container>
                              <div class="view-layout">
                                <div *ngFor="let gender of targetAudienceDetails.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium">{{gender}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Intent:</div>
                            <div><span class="mwc-text-sm-medium">{{targetAudienceDetails.thingTargetAudience.thingJson.intent}}</span></div>
                          </div>
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Industry:</div>
                            <ng-container>
                              <div class="view-layout">
                                <div *ngFor="let industry of targetAudienceDetails.thingTargetAudience.thingJson.industry;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium">{{industry}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                          <div mwc-col [mwcSpan]="12">
                            <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Interests:</div>
                            <div style="display: flex;gap:16px;align-items: center;">
                              <ng-container>
                                <div class="view-layout">
                                  <div *ngFor="let interests of targetAudienceDetails.thingTargetAudience.thingJson.interests;let last = last; let first = first;">
                                    <span class="mwc-text-sm-medium">{{interests}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- Language Check Tab Content -->
              <ng-container *ngIf="tab.name === 'Language'">
                <div class="mwc-text-lg-medium mb-3">Language</div>

                <mwc-form-item>
                  <mwc-form-label [mwcSpan]="24" mwcFor="language">Select Base Language</mwc-form-label>
                  <mwc-form-control [mwcSpan]="24">
                    <div>
                      <mwc-select class="select-language" mwcSize="small" mwcDropdownClassName="select-language-dropdown"
                                  [mwcShowArrow]="true" [(ngModel)]="selectedValueLanguage" formControlName="language"
                                  [mwcCustomTemplate]="defaultTemplate" mwcPlaceHolder="Select language"
                                  class="mwc-xs-select mwc-text-sm-medium select-language" [mwcOptionHeightPx]="36"
                                  (ngModelChange)='languageChanged($event)'>
                        <mwc-option *ngFor="let item of provinceData" mwcCustomContent [mwcLabel]="item.label"
                                    [mwcValue]="item.value">
                          {{item.label}} <span mwc-icon [mwcIconfont]="item.value"></span>
                        </mwc-option>
                      </mwc-select>
                      <ng-template #defaultTemplate let-selected>
                        <span mwc-icon [mwcIconfont]="selected.mwcValue"></span>
                        {{ selected.mwcLabel }}
                      </ng-template>
                    </div>
                  </mwc-form-control>
                </mwc-form-item>
              </ng-container>

            
            </div>
          </mwc-tab>
        </ng-container>
      </ng-container>
    </mwc-tabset>
  </form>
  
  <!-- Navigation Buttons moved below template-container -->
  <div class="workflow-navigation">
    <!-- Left side - permanent Change Workflow button -->
    <div class="left-button">
      <button mwc-button mwcType="link-color" (click)="onChangeWorkflow()" [disabled]="isAnalyzing" *ngIf="selectedIndex == 0 || selectedIndex == 1">
        <span mwc-icon [mwcIconfont]="'arrow-left'"></span>
        Change Workflow
      </button>
    </div>
    
    <!-- Right side - dynamic buttons based on tab -->
    <div class="right-buttons">
      <!-- Tab-specific action buttons -->
      <ng-container [ngSwitch]="selectedIndex" class="button-sec">
        <ng-container *ngSwitchCase="0">
          <button mwc-button mwcType="primary" mwcSize="small" (click)="onNext()" [disabled]=" !( (workflowForm.controls['websiteUrl'].value?.length > 0 && !workflowForm.controls['individualUrls'].value?.trim()) || (workflowForm.controls['individualUrls'].value?.trim() && !(workflowForm.controls['websiteUrl'].value?.length > 0)) || brandSelectedValue ) || workflowForm.controls.websiteUrl.invalid || workflowForm.controls.websiteUrl.pending || workflowForm.controls.individualUrls.hasError('invalidUrl') || workflowForm.controls['websiteUrl'].hasError('invalidUrl') || brandSelectedValue==''">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <button mwc-button mwcType="default" (click)="selectedIndex = 0" [disabled]="isAnalyzing">Back</button>
          <button mwc-button mwcType="primary" (click)="proceedFromKeywords()" [disabled]="allKeywords.length === 0 || keywordAnalysisinProgress">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <button mwc-button mwcType="default" (click)="selectedIndex = 1">Back</button>
          <!-- <button mwc-button mwcType="default-color" (click)="uploadInstructions()" [disabled]="isButtonDisabled()">
      Upload Instructions
    </button> -->
          <button mwc-button mwcType="primary" (click)="onNext()" [disabled]="isButtonDisabled()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <button mwc-button mwcType="default" (click)="selectedIndex = 2">Back</button>
          <ng-container>
            <button mwc-button mwcType="primary" (click)="onNext()">{{uploadedFiles.length == 0?'Skip & Proceed':'Proceed'}}</button>
          </ng-container>         
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <button mwc-button mwcType="default" (click)="selectedIndex = 3">Back</button>
          <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="5">
          <button mwc-button mwcType="default" (click)="selectedIndex = 4">Back</button>
          <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="6">
          <button mwc-button mwcType="default" (click)="selectedIndex = 5">Back</button>
          <ng-container *ngIf="showContentInstructions">
            <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
          </ng-container>
          <ng-container *ngIf="!showContentInstructions">
            <button mwc-button mwcType="primary" (click)="onSubmitNew()" [disabled]="isButtonDisabled()"><span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>Generate</button>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="7">
          <button mwc-button mwcType="default" (click)="selectedIndex = 6">Back</button>
          <button mwc-button mwcType="primary" (click)="onSubmitNew()" [disabled]="isButtonDisabled()"><span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>Generate</button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!--Waiting Screen for Analysis-->
<mwc-modal [(mwcVisible)]="waitingScreenforAnalysis" [mwcClosable]="false" [mwcFooter]="null"
  [mwcWidth]="'400px'" [mwcCentered]="true">
  <div *mwcModalContent>
    <div class="analysis-in-progress">
      <div class="analysis-in-progress-img"><img src="assets/images/ai-loader.gif" alt="Analyzing" style="height: 50px; width: 50px;"></div>
      <div>
        <div class="mwc-text-lg-medium">Analysis in progress </div>
        <div class="mwc-text-sm-regular">We’re scanning your pages and matching them to keywords and templates. <span class="mwc-text-sm-medium mwc-color-gray-900">This may take a few minutes.</span> You can wait or resume later from My Campaigns.</div>
      </div>
      <div><button [disabled]="!isGoToCampaignsEnabled" (click)="goToMyCampaigns()" mwc-button mwcType="primary">Go to My Projects</button></div>
    </div>
  </div>
</mwc-modal>

<!-- Add Brand Modal -->
<mwc-modal [(mwcVisible)]="isAddBrandModalVisible" mwcWidth="610px" [mwcCentered]="true" (mwcOnCancel)="cancelAddBrand()" [mwcFooter]="null" [mwcBodyStyle]="{'padding': '0'}" [mwcTitle]="brandTitle" [mwcContent]="brandContent" [mwcFooter]="brandFooter" [mwcClassName]="'brand-modal'">
  <ng-template #brandTitle>
    <div class="title-header">
      <div class="mwc-icon-highlight-primary-md">
        <span mwc-icon mwcIconfont="plus" style="font-size: 18px"></span>
      </div>
      <div>
        <div class="mwc-text-lg-medium mwc-color-gray-900">Create New Brand</div>
      </div>
    </div>
  </ng-template>
  <ng-template #brandContent>
    <div style="padding: 16px 24px;border-bottom: 1px solid rgb(234, 236, 240);border-top: 1px solid rgb(234, 236, 240);">
      <div class="mwc-text-sm-medium mwc-color-gray-700 mb-2">Brand Name</div>
      <input class="mwc-input" [(ngModel)]="newBrandName" placeholder="Enter brand name" style="width: 100%; padding: 10px; border-radius: 8px; border: 1px solid #D0D5DD; height: 36px;">
    </div>
  </ng-template>
  <ng-template #brandFooter>
    <button mwc-button mwcType="default" (click)="cancelAddBrand()" mwcSize="small">Cancel</button>
    <button mwc-button mwcType="primary" (click)="createNewBrand()" mwcSize="small" [disabled]="!newBrandName?.trim()">Create Brand</button>
  </ng-template>
</mwc-modal>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

<ng-template #tableSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; min-height: 150px; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

